import { createRouter, createWebHistory } from 'vue-router'

// 這是文章數量的記錄表，會迴圈將路由選項推入routes裡面，每次有新文章要修改的是這裡
const postList = [
  {
    name: 'Accident',
    list: {
      A: 8,
      B: 5
    }
  },
  {
    name: 'Procedure',
    list: {
      C: 8,
      D: 8,
      E: 5
    }
  },
  {
    name: 'Compensation',
    list: {
      F: 5,
      G: 1,
      H: 6,
      I: 6,
      J: 5,
      K: 5
    }
  },
  {
    name: 'Safe',
    list: {
      L: 11,
      M: 1
    }
  }
]

const routes = [
  {
    path: '/',
    name: 'Home',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/News.vue'),
    children: []
  },
  {
    path: '/accident',
    name: 'Accident',
    component: () =>
      import(/* webpackChunkName: "accident" */ '../views/Accident.vue'),
    children: []
  },
  {
    path: '/compensation',
    name: 'Compensation',
    component: () =>
      import(
        /* webpackChunkName: "compensation" */ '../views/Compensation.vue'
      ),
    children: []
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () =>
      import(/* webpackChunkName: "contact" */ '../views/Contact.vue'),
    children: []
  },
  {
    path: '/documents',
    name: 'Documents',
    component: () =>
      import(/* webpackChunkName: "documents" */ '../views/Documents.vue'),
    children: []
  },
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/procedure',
    name: 'Procedure',
    component: () =>
      import(/* webpackChunkName: "procedure" */ '../views/Procedure.vue'),
    children: []
  },
  {
    path: '/register',
    name: 'Register',
    component: () =>
      import(/* webpackChunkName: "register" */ '../views/Register.vue')
  },
  {
    path: '/safe',
    name: 'Safe',
    component: () => import(/* webpackChunkName: "safe" */ '../views/Safe.vue'),
    children: []
  },
  {
    path: '/newedit',
    name: 'NewEdit',
    component: () => import(/* webpackChunkName: "safe" */ '../views/NewEdit.vue')
  }
]
// 根據postList動態設定路由，第一層迴圈對應routes的頁面，每一個頁面都會先與postList查詢
// 裡面有沒有此頁面的子文件，如果有的話，開始動態配置路由
for (var i = 0; i < routes.length; i++) {
  // 查詢postList裡有沒有這個頁面的子文件
  if (postList.filter(e => e.name === routes[i].name).length > 0) {
    // 第二層迴圈，遍歷postList裡的子文件分類，取其key
    // 以i = 2，routes[i].name=Accident為例，有兩個分類：A、B
    // 這樣第二層迴圈將跑兩次，以分類(key)查詢postList裡 分類的文件數，將其文件數跑第三次迴圈，開始動態配置路由
    for (var key in postList.filter(e => e.name === routes[i].name)[0].list) {
      for (
        var j = 1;
        j <= postList.filter(e => e.name === routes[i].name)[0].list[key];
        j++
      ) {
        // 必要，修正不明問題：以template literals進行組件匯入時 迴圈變數錯亂的問題
        const tempkey = key
        const tempj = j
        routes[i].children.push({
          path: key + '' + j,
          name: key + '' + j,
          // https://webpack.js.org/api/module-methods/#magic-comments
          // https://stackoverflow.com/questions/52339114/how-to-generate-dynamic-import-chunk-name-in-webpack
          // 動態生成Webpack動態載入chunk
          component: () =>
            import(
              /* webpackChunkName: "[request]" */ `../components/${tempkey}/${tempkey}${tempj}.vue`
            )
        })
      }
    }
  }
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
